<template>
  <div class="mobile-bottom-nav">
    <button 
      class="nav-item"
      @click="$emit('navigate-tables')"
    >
      <font-awesome-icon icon="fa-solid fa-table" class="nav-icon" />
      <span class="nav-label">Tables</span>
    </button>
    
    <button 
      class="nav-item cart-item"
      :class="{ 'has-items': cartCount > 0 }"
      @click="$emit('open-cart')"
    >
      <div class="cart-icon-wrapper">
        <font-awesome-icon icon="fa-solid fa-shopping-cart" class="nav-icon" />
        <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
      </div>
      <span class="nav-label">Cart</span>
      <span v-if="cartCount > 0" class="cart-total">{{ formatTotal(cartTotal) }}</span>
    </button>
    
    <button 
      class="nav-item"
      :class="{ disabled: cartCount === 0 }"
      :disabled="cartCount === 0"
      @click="$emit('navigate-payment')"
    >
      <font-awesome-icon icon="fa-solid fa-money-bill-wave" class="nav-icon" />
      <span class="nav-label">Pay</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomNav',
  props: {
    cartCount: {
      type: Number,
      default: 0
    },
    cartTotal: {
      type: Number,
      default: 0
    }
  },
  methods: {
    formatTotal(total) {
      return this.$utils.formatMoney(total);
    }
  }
};
</script>

<style scoped lang="scss">
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: linear-gradient(135deg, var(--card-bg) 0%, var(--secondary-button-bg) 100%);
  border-top: var(--card-border);
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  z-index: 999;
  padding: 8px 8px calc(8px + env(safe-area-inset-bottom));
  gap: 8px;
  
  @supports (backdrop-filter: blur(10px)) {
    backdrop-filter: blur(10px);
    background: linear-gradient(
      135deg, 
      rgba(var(--card-bg), 0.9) 0%, 
      rgba(var(--secondary-button-bg), 0.9) 100%
    );
  }
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: var(--button-radius);
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: var(--transition-default);
  padding: 8px;
  position: relative;
  
  &:active:not(.disabled) {
    transform: scale(0.95);
    background: rgba(var(--accent-electric-blue-rgb), 0.1);
  }
  
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  
  .nav-icon {
    font-size: 24px;
    transition: var(--transition-default);
  }
  
  .nav-label {
    font-size: 12px;
    font-weight: 600;
    transition: var(--transition-default);
  }
  
  &.cart-item {
    background: linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-primary-dark) 100%);
    color: white;
    box-shadow: 0 4px 16px rgba(var(--accent-electric-blue-rgb), 0.4);
    
    &.has-items {
      animation: pulse 2s ease-in-out infinite;
    }
    
    &:active {
      transform: scale(0.95);
      box-shadow: 0 2px 8px rgba(var(--accent-electric-blue-rgb), 0.3);
    }
    
    .cart-icon-wrapper {
      position: relative;
      
      .cart-badge {
        position: absolute;
        top: -8px;
        right: -8px;
        background: var(--danger);
        color: white;
        border-radius: 12px;
        padding: 2px 6px;
        font-size: 10px;
        font-weight: 700;
        min-width: 20px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }
    
    .cart-total {
      font-size: 11px;
      font-weight: 700;
      opacity: 0.9;
    }
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
}
</style>
